<template>
    <div>
    <transition
        enter-active-class="transition duration-200 ease-out"
        leave-active-class="transition duration-200 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div v-if="modelValue" class="fixed inset-0 bg-neutral-700 bg-opacity-50" />
    </transition>
    <transition
        enter-active-class="transition duration-200 ease-out"
        leave-active-class="transition duration-200 ease-out"
        enter-from-class="opacity-0 translate-y-10"
        enter-to-class="opacity-100 translate-y-0"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 translate-y-10"
    >
        <SfModal
        v-model="modelValue"
        class="max-w-[90%] md:max-w-lg"
        :class="props.sectionClasses"
        tag="section"
        role="alertdialog"
        aria-labelledby="promoModalTitle"
        aria-describedby="promoModalDesc"
        >
            <header>
                <SfButton square variant="tertiary" class="absolute right-2 top-2" @click="close">
                    <SfIconClose />
                </SfButton>
            </header>
            <slot />
        </SfModal>
    </transition>
    </div>
</template>
  
<script lang="ts" setup>  
import { SfModal, SfButton, SfIconClose} from '@storefront-ui/vue';
let modelValue = defineModel();
let props = defineProps({
    sectionClasses: {
        type: Object as PropType<Record<string, boolean>>,
        default: () => ({
            'max-w-[90%]': true,
            'md:max-w-lg': true,
        })
    }
})
let close = () => {
    modelValue.value = false;
}
</script>